import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";

const Tabs = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { id } = useParams();

  const tabs = [
    {
      path: `/dashboard/agents/info/${id}/evaluate/datasets`,
      label: "Datasets",
    },
    {
      path: `/dashboard/agents/info/${id}/evaluate/history`,
      label: "History",
    },
  ];

  const isActiveTab = (tabPath: string) => {
    // Check if current path matches tab path exactly
    if (currentPath === tabPath) return true;

    // Get the segments of both paths
    const tabSegments = tabPath.split("/");
    const currentSegments = currentPath.split("/");

    return tabSegments[6] === currentSegments[6];
  };

  return (
    <div className="mb-4 mt-2 flex w-full flex-col items-center border-b border-[#ececec]  shadow-2xl shadow-white dark:border-navy-700  dark:!shadow-none xl:mb-3">
      <div className="flex w-full justify-start gap-11 overflow-hidden text-3xl">
        {tabs.map((tab) => (
          <Link
            key={tab.path}
            to={tab.path}
            className={`flex items-center gap-2 border-b-[4px] pb-3 hover:cursor-pointer ${
              isActiveTab(tab.path)
                ? "border-brand-500 dark:border-brand-400"
                : "border-white dark:!border-navy-800"
            }`}
          >
            <h5 className="text-base font-medium text-navy-700 dark:text-white">
              {tab.label}
            </h5>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
